import { render, staticRenderFns } from "./EstimatedReadTime.vue?vue&type=template&id=5b0ebb27&scoped=true&"
import script from "./EstimatedReadTime.vue?vue&type=script&lang=js&"
export * from "./EstimatedReadTime.vue?vue&type=script&lang=js&"
import style0 from "./EstimatedReadTime.vue?vue&type=style&index=0&id=5b0ebb27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ebb27",
  null
  
)

export default component.exports